import React from "react";
import "./styles.css";
function Header() {
  return (
    <div className="header h1">
      <h1>Keeper</h1>
    </div>
  );
}
export default Header;